import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { AvalancheAdvisory } from 'components/avalanche-advisory/avalanche-advisory.js';
import { IModule } from 'redux-state/layout/types.js';

interface IProps {
  location: string;
}

const AvalancheAdvisoryWidget = (props: IModule<IProps>) => {
  const {
    config: { location },
  } = props;

  return (
    <Tile dataModule="avalanche-advisory-widget" {...props}>
      <div className="Tile-body">
        <TileBodyHeaderV2 {...props} />
        <AvalancheAdvisory className="u-mT-responsive" location={location} />
      </div>
    </Tile>
  );
};

export { AvalancheAdvisoryWidget };
